<script setup>
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { onMounted, computed, h } from 'vue';
import {
  useVueTable,
  createColumnHelper,
  getCoreRowModel,
} from '@tanstack/vue-table';
import Table from 'dashboard/components/table/Table.vue';
import AgentCell from './AgentCell.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const store = useStore();
const agents = useMapGetter('agents/getAgents');

const structuredAgentMetrics = computed(() => {
  return agents.value
    .map(agent => {
      return {
        agent: agent.available_name || agent.name,
        email: agent.email,
        thumbnail: agent.thumbnail,
        status: agent.availability_status,
      };
    })
    .sort((a, b) => a.agent.localeCompare(b.agent));
});

const defaulSpanRender = cellProps =>
  h(
    'span',
    {
      class: cellProps.getValue()
        ? 'capitalize text-n-slate-12'
        : 'capitalize text-n-slate-11',
    },
    cellProps.getValue() ? cellProps.getValue() : '---'
  );

const columnHelper = createColumnHelper();
const columns = [
  columnHelper.accessor('agent', {
    header: t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TABLE_HEADER.AGENT'),
    cell: cellProps => h(AgentCell, cellProps),
    size: 250,
  }),
  columnHelper.accessor('status', {
    header: t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TABLE_HEADER.STATUS'),
    cell: defaulSpanRender,
    size: 100,
  }),
];

const table = useVueTable({
  get data() {
    return structuredAgentMetrics.value;
  },
  columns,
  enableSorting: false,
  getCoreRowModel: getCoreRowModel(),
});

onMounted(() => {
  store.dispatch('agents/get');
});
</script>

<template>
  <div class="pt-2">
    <Table :table="table" />
  </div>
</template>
